<script>
import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'

export default {
    props: {
        label: {
            type: String,
            required: false,
        },
        labelClass: {
            type: String,
            required: false,
        },
        value: {
            type: String,
        },
        errorMessage: {
            type: String,
            required: false,
        },
        readonly: {
            type: Boolean,
            default: true,
        },
        variant: {
            type: () => ['outlined', 'text'],
            default: 'outlined',
        },
    },
    components: {
        EditorViewer,
    },
}
</script>

<template>
    <div class="tw-w-full">
        <slot v-if="$slots['label']" name="label"></slot>
        <label v-else-if="label" class="text-body-2" :class="labelClass">{{ label }}</label>

        <v-sheet
            v-if="!readonly"
            v-bind="$attrs"
            outlined
            rounded
            class="grey--text text--darken-1 overflow-hidden tw-w-full tw-border-none"
            elevation="1"
            :color="errorMessage ? 'red' : ''"
        >
            <slot></slot>
        </v-sheet>
        <v-sheet
            v-else-if="value"
            v-bind="$attrs"
            :outlined="variant === 'outlined'"
            class="tw-border-none tw-bg-transparent tw-pl-2"
            rounded
        >
            <EditorViewer :description="value" />
        </v-sheet>

        <span v-if="errorMessage" class="red--text text-body-2">
            {{ errorMessage }}
        </span>
    </div>
</template>
